<template>
    <div class="model-assemble">
        <div class="model-assemble-header">
            <el-button icon="update-icon iconfont iconshangchuan" type="primary" @click="addModelAssembleHandle" round
                >&nbsp; 模型组装
            </el-button>
            <el-button
                icon="iconfont iconxingzhuang"
                type="danger"
                :disabled="!(selectModels.length > 0)"
                @click="delModelList"
                round
                >&nbsp; 删除文件
            </el-button>
        </div>
        <div class="model-assemble-content" v-loading="isTableLoading">
            <div class="model-assemble-table">
                <el-table
                    stripe
                    tooltip-effect="dark"
                    highlight-current-row
                    style="width: 100%;"
                    :data="currentModelAssembleList"
                    :header-cell-style="{
                        'background-color': '#F5F5F5',
                        'font-size': '14px',
                        color: '#666666',
                        'font-weight': '400',
                    }"
                    @selection-change="selectModelAssemble"
                >
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column
                        prop="packageName"
                        label="组装名称"
                        show-overflow-tooltip
                        min-width="80%"
                    ></el-table-column>
                    <el-table-column prop="startTime" label="开始时间" show-overflow-tooltip min-width="60%">
                        <template slot-scope="scope">
                            {{ formatTime(scope.row.startTime) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="num" label="组装文件数" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="status" label="状态" show-overflow-tooltip>
                        <template>
                            <span style="color: #22c00e;">组装成功</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="convertType" label="组装方式" sortable show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span v-if="scope.row.convertType === 'obv'">全量组装</span>
                            <span v-if="scope.row.convertType === 'lod'">流式组装</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <i
                                @click="viewModelAssemble(scope.row)"
                                class="model-assemble-icon iconfont iconliulan-moren"
                            ></i>
                            <i
                                @click="editModelAssemble(scope.row)"
                                class="model-assemble-icon iconfont iconcanshubianji"
                            ></i>
                            <i
                                @click="shareModelAssemble(scope.row)"
                                class="model-assemble-icon iconfont iconfenxiang viewmodel-icon"
                            ></i>
                            <!--                    <i class="el-icon-share"></i>-->
                            <i
                                @click="delModelAssemble(scope.row)"
                                class="model-assemble-icon model-assemble-icon-del iconfont iconxingzhuang"
                            ></i>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="paging">
            <el-pagination
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                layout="prev, pager, next"
                :total="totalCount"
                :page-size="pageSize"
            >
            </el-pagination>
        </div>
        <SelectViewerDialog
            @add-view="addView"
            @remove-all-view="removeAllView"
            @ok="saveModelAssemble"
            @close="closeDialog"
            :dialogVisible="dialogVisible"
            :beginStatus="beginStatus"
            title="模型组装"
            :is-show2d="false"
            headerName="组装名称"
        >
            <ShowModelPosition
                :data="addModelAssemble.packageParamsMetadataList"
                :isShowOperate="true"
                :removeView="removeView"
            ></ShowModelPosition>
        </SelectViewerDialog>
        <el-dialog title="模型组装参数编辑" :visible.sync="editDialogVisible" width="40%" :before-close="handleClose">
            <el-input
                style="padding: 0 80px 0 10px;"
                class="dialog-name"
                placeholder="请输入内容"
                v-model.trim="editModelAssembleData.packageName"
            >
                <template slot="prepend">组装名称：</template>
            </el-input>
            <ShowModelPosition
                file-title="文件视图"
                :data="editModelAssembleData.packageParamsMetadataList"
            ></ShowModelPosition>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveModelAssemblePosition">保 存</el-button>
                <el-button @click="editDialogVisible = false">取 消</el-button>
            </span>
        </el-dialog>
        <modelViewsShare ref="modelViewsShare" :isDownload="false"></modelViewsShare>
        <contactUsCom @send-message="sendMessage" ref="contactUsCom"></contactUsCom>
    </div>
</template>

<script>
import SelectViewerDialog from './SelectViewerDialog';
import contactUsCom from 'src/pages/devCenter/consoleLab/components/contactUsCom';
import modelViewsShare from 'src/pages/devCenter/consoleLab/components/modelViews-share';
import {
    addModelAssembleRequest,
    deleteModelAssemble,
    editModelAssembleView,
    getModelAssembleList,
    getModelAssembleView,
} from '../../../../utils/modelAssemble';
import ShowModelPosition from './ShowModelPosition.vue';
import { base64UrlEncode } from '../../../../utils/commonUtils';
import { formatTime } from '../../../../utils/commonUtils';
import { getAppInfo } from '../../../../utils/appUtils';
import { sendEmailToAccountUpgrade } from 'src/utils/sendMessage';

class ModelAssembleTmp {
    packageName = '';
    num = 0;
    packageParamsMetadataList = [];
}

export default {
    name: 'modelAssemble',
    components: {
        SelectViewerDialog,
        ShowModelPosition,
        modelViewsShare,
        contactUsCom,
    },
    computed: {
        isTrial() {
            return this.userType === 'trial';
        },
        currentModelAssembleList() {
            return this.modelAssembleList.slice(
                (this.currentPage - 1) * this.pageSize,
                this.currentPage * this.pageSize,
            );
        },
    },
    data() {
        return {
            addModelAssemble: {},
            editModelAssembleData: {},
            dialogVisible: false,
            beginStatus: false,
            editDialogVisible: false,
            modelAssembleList: [],
            selectModels: [],
            userType: 'trial',
            isTableLoading: false,
            currentPage: 1, // 分页相关
            totalCount: 0,
            pageSize: 14,
        };
    },
    methods: {
        formatTime: formatTime,
        addModelAssembleHandle() {
            if (this.modelAssembleList.length >= 3 && this.isTrial) {
                this.$refs.contactUsCom.Open('你已达到模型组装个数的最大限制，请升级账户!');
                return;
            }
            this.dialogVisible = true;
            this.beginStatus = false;
        },
        selectModelAssemble(data) {
            this.selectModels = data;
        },
        delModelList() {
            this.$confirm('确认删除选中的模型组装？')
                .then((_) => {
                    Promise.all(this.selectModels.map((item) => deleteModelAssemble(item.id))).then(async () => {
                        this.$message.success('删除成功!');
                        await this.getModelAssembleList();
                        if (this.currentPage > 1 && this.pageSize * (this.currentPage - 1) === this.totalCount) {
                            this.currentPage--;
                        }
                    });
                })
                .catch((_) => {});
        },
        saveModelAssemblePosition() {
            if (!this.editModelAssembleData.packageName) {
                this.$message.warning('请输入模型组装的名称!');
                return;
            }
            if (this._formatPosition(this.editModelAssembleData.packageParamsMetadataList)) {
                editModelAssembleView(
                    this.editModelAssembleData.packageName,
                    this.editModelAssembleData.packageParamsMetadataList,
                ).then(() => {
                    this.$message.success('修改成功!');
                    this.editDialogVisible = false;
                    this.editModelAssembleData = {};
                });
            }
        },
        // 区分convertType
        viewModelAssemble(row) {
            const tempURL = `${window.location.origin}/devcenter/console/view?name=${base64UrlEncode(
                row.packageName,
            )}&viewModelType=assemble&assembleId=${row.id}&convertType=${row.convertType}`;
            window.open(tempURL, '_blank');
        },
        editModelAssemble(row) {
            getModelAssembleView(row.id).then((data) => {
                this.editModelAssembleData = row;
                this.editModelAssembleData.packageParamsMetadataList = data;
                this.editDialogVisible = true;
            });
        },
        delModelAssemble(row) {
            this.$confirm('确认删除的模型组装？')
                .then((_) => {
                    deleteModelAssemble(row.id).then(async () => {
                        this.$message.success('删除成功!');
                        await this.getModelAssembleList();
                        if (this.currentPage > 1 && this.pageSize * (this.currentPage - 1) === this.totalCount) {
                            this.currentPage--;
                        }
                    });
                })
                .catch((_) => {});
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then((_) => {
                    done();
                })
                .catch((_) => {});
        },
        closeDialog() {
            this.addModelAssemble = new ModelAssembleTmp();
            this.dialogVisible = false;
        },
        saveModelAssemble(data) {
            if (!data.name) {
                this.$message.warning('请输入模型组装的名称!');
                return;
            }
            if (this.addModelAssemble.packageParamsMetadataList.length <= 0) {
                this.$message.warning('请选择视图!');
                return;
            }
            if (data.convertType === 'lod') {
                this.addModelAssemble.type = 1;
            }
            this.addModelAssemble.packageName = data.name;
            this.addModelAssemble.num = this.addModelAssemble.packageParamsMetadataList.length;
            if (this._formatPosition(this.addModelAssemble.packageParamsMetadataList)) {
                this.beginStatus = true;
                addModelAssembleRequest(this.addModelAssemble)
                    .then(() => {
                        this.closeDialog();
                        this.getModelAssembleList();
                        this.$message.success('新增模型组装成功！');
                    })
                    .catch((e) => {
                        this.beginStatus = false;
                        this.$message.error('保存失败请重试!' + e);
                    });
            }
        },
        addView({ urn, view, object }) {
            // 使用displayName 判断因为 文件的object key 不一样 但是 guid 会有可能一样
            const displayName = object.fileName + '_' + view.name;
            const item = this.addModelAssemble.packageParamsMetadataList.find(
                (item) => item.displayName === displayName,
            );
            if (item) {
                this.$message.warning('当前视图已经添加到已选文件视图中，不能重复添加!');
                return;
            }
            this.addModelAssemble.packageParamsMetadataList.push({
                guid: view.guid,
                x: 0,
                y: 0,
                z: 0,
                r: 0,
                urn: urn,
                displayName,
            });
        },
        removeView(view) {
            const index = this.addModelAssemble.packageParamsMetadataList.findIndex(
                (item) => item.displayName === view.displayName,
            );
            if (index !== -1) {
                this.addModelAssemble.packageParamsMetadataList.splice(index, 1);
            }
        },
        removeAllView() {
            this.addModelAssemble.packageParamsMetadataList = [];
        },
        async getModelAssembleList() {
            this.isTableLoading = true;
            this.modelAssembleList = await getModelAssembleList();
            this.totalCount = this.modelAssembleList.length;
            this.isTableLoading = false;
        },
        handleCurrentChange(val) {
            this.currentPage = val;
        },
        _formatPosition(list) {
            list.forEach((item) => {
                // 校验数值正确
                let reg = /^(-?\d+)(\.\d+)?$/;
                if (reg.test(item.x) && reg.test(item.y) && reg.test(item.z)) {
                    item.x = typeof item.x !== '' ? parseFloat(item.x) : null;
                    item.y = typeof item.y !== '' ? parseFloat(item.y) : null;
                    item.z = typeof item.z !== '' ? parseFloat(item.z) : null;
                } else {
                    this.$message({
                        message: '不能输入非法字符',
                        type: 'warning',
                    });
                    return false;
                }
            });
            return true;
        },
        shareModelAssemble(row) {
            this.fileName = row.packageName;
            this.currentUrn = `bimbox.object:${row.packageName}`;
            // 获取urn进行拼接
            getModelAssembleView(row.id).then((data) => {
                let query = {
                    cardName: row.packageName,
                    guid: '',
                    type: row.convertType === 'obv' ? 2 : 5,
                    packageId: row.id,
                };
                this.$refs.modelViewsShare.Open(
                    {
                        fileName: this.fileName,
                        urn: this.currentUrn,
                        objectStatus: {
                            obv: row.convertType === 'obv' ? '完成转换' : null,
                            lod: row.convertType === 'lod' ? '完成转换' : null,
                        },
                    },
                    query,
                );
            });
        },
        sendMessage(text) {
            if (!text) {
                this.$message.warning('联系内容不为空！');
                return;
            }
            // todo 后台接口限制 每10分钟 才能发一次
            sendEmailToAccountUpgrade(text)
                .then(() => {
                    this.$refs.contactUsCom.close();
                    this.$message.success('发送邮件成功！');
                })
                .catch((e) => {
                    let error = '';
                    if (e && e.responseText.indexOf('请求太频繁了，休息一会吧。') !== -1) {
                        error = '请求太频繁了，休息一会吧。';
                    }
                    this.$message.error(`发送失败！请重试${error}`);
                });
        },
    },
    async mounted() {
        getAppInfo()
            .then((appRes) => {
                // 判断是否是第一次使用app
                if (appRes.items.length >= 0) {
                    // 账户状态 trial commercial
                    this.userType = appRes.items[0].type;
                }
            })
            .catch(() => {
                this.isTableLoading = false;
            });
        this.addModelAssemble = new ModelAssembleTmp();
        await this.getModelAssembleList();
    },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
.model-assemble
  background-color $background-darkwhite
  width 88%

  .model-assemble-header
    padding 15px 15px

  .model-assemble-content
    width 100%
    height 85%
    overflow auto

    .model-assemble-table
      width 99%
      margin 0 auto

  .paging, .model-assemble-icon
    padding 0 8px
    cursor pointer

  .model-assemble-icon:hover
    color #0C78E2

  .model-assemble-icon-del:hover
    color #e20c25 !important
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/consoleLab/ModelAssemble/ModelAssemble.vue